// identity
const ChangePassword: Function = () => import("@app/identity/view/logonworkflow/change-password");
const ForgotPassword: Function = () => import("@app/identity/view/logonworkflow/forgot-password");
const ResetPassword: Function = () => import("@app/identity/view/logonworkflow/reset-password");
const TwoFactorLogin: Function = () => import("@app/identity/view/logonworkflow/two-factor-login");
const Login: Function = () => import("@app/identity/view/logonworkflow/login");
const TwoFactorVerification: Function = () => import("@app/identity/view/logonworkflow/twoFactorVerificationView");

export default class ModulesLoader {
    private modules: any = {
        // identity
        ChangePassword,
        ForgotPassword,
        ResetPassword,
        TwoFactorLogin,
        Login,
        TwoFactorVerification
    };

    private setup(): void {
        let scripts = $("script[data-module]");
        $.each(scripts, (index, value) => {
            let moduleName: string = $(value).data("module");
            if (moduleName) {
                this.loadModule(this.modules[moduleName]);
            }
        });
    }

    private loadModule(moduleLoader: Function): void {
        if (moduleLoader && typeof (moduleLoader) === typeof (Function)) {
            moduleLoader().then((loadedModule: any) => {
                // tslint:disable-next-line:no-unused-expression
                new loadedModule.default();
            });
        }
    }

    init(): void {
        this.setup();
    }
}